export default "__VITE_ASSET__ByMcKSf6__"